<script>
export default {
    name: "ViewFileModal",

    props: {
        file: {
            type: Object,
            required: true,
        },
        showModal: Boolean,
    },
}
</script>
<template>
  <tail-modal :show="showModal" dimension="w-10/12">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Medical Document</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
        <div class=" flex flex-col items-center w-full p-1 my-2">
            <h5 class="font-medium text-sm my-1">Name: {{ file.docName }}</h5>
            <iframe
              v-if="file.contentType == `application/pdf`"
              :src="`data:application/pdf;base64,${file.document}`"
              height="800"
              width="1150"
            ></iframe>
            <img
              v-else
              :src="`data:application/image;base64,${file.document}`"
              :alt="file.docName"
            />
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click.prevent="$emit(`closeModal`)"
      >
        <i class="fa fa-times"></i> Close
      </button>
    </template>
  </tail-modal>
</template>
